var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMagnificaitonPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.129,
    height: 22.129,
    viewBox: "0 0 22.129 22.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.536,42.175H11.954V32.593A.594.594,0,0,0,11.361,32h-.593a.594.594,0,0,0-.593.593v9.583H.593A.594.594,0,0,0,0,42.768v.593a.594.594,0,0,0,.593.593h9.583v9.583a.594.594,0,0,0,.593.593h.593a.594.594,0,0,0,.593-.593V43.954h9.583a.594.594,0,0,0,.593-.593v-.593A.594.594,0,0,0,21.536,42.175Z",
    transform: "translate(0 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagnificaitonPlus);
export default __webpack_public_path__ + "static/media/Icon-Magnificaiton-Plus.8e00827923e48c66ebe12066418a7d83.svg";
export { ForwardRef as ReactComponent };